// extracted by mini-css-extract-plugin
export default {"footer":"InfoEditModal_footer__mWpqY","cancel_btn":"InfoEditModal_cancel_btn__8ozMj"};